import classNames from 'classnames'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link, Outlet, useLocation } from 'react-router-dom'

import { CallModal } from '@components/CallModal'

import { LangSelect } from '@UI/LangSelect'
import { NavAccordion } from '@UI/NavAccordion'

import { useActions } from '@hooks/useActions'
import { useCall } from '@hooks/useCall'
import useToggle from '@hooks/useToggle'

import { routes } from '@/constants/routes'
import { useGetLanguagesQuery } from '@/store/api'
import { useSignOutMutation } from '@/store/auth/auth.api'
import { ReactComponent as Profile } from '@assets/icons/profile.svg'
import { ReactComponent as Settings } from '@assets/icons/settings.svg'
import { ReactComponent as SignOut } from '@assets/icons/sign-out.svg'
import bee from '@assets/images/aside-bee.svg'
import logo from '@assets/images/logo.png'

import s from './MainLayout.module.scss'
import { MainLayoutProps } from './MainLayout.props'

export function MainLayout({}: MainLayoutProps) {
  const { t } = useTranslation()
  const { pathname } = useLocation()

  useGetLanguagesQuery({})
  const [signOut] = useSignOutMutation()
  const { setAuth } = useActions()

  const [isHidden, toggleHidden] = useToggle(false)

  const { modalIsVisible, target } = useCall()

  const signOutHandler = () => {
    signOut({})
      .unwrap()
      .then((res) => {
        if (res.status === 'success') {
          localStorage.removeItem('accessToken')
          localStorage.removeItem('login')
          setAuth(false)
        }
      })
      .catch(() => {})
  }

  return (
    <div className={s.layout}>
      <aside className={classNames(s.aside, { [s.hidden]: isHidden })}>
        <Link
          to={'/catalog/products'}
          className={s.logo}
        >
          <img
            src={logo}
            alt="logo"
          />
        </Link>

        {routes.map((i) => (
          <NavAccordion
            key={i.rootPath}
            route={i}
          />
        ))}

        <img
          src={bee}
          alt="bee"
          className={s.asideImg}
        />
      </aside>

      <div className={s.main}>
        <div className={s.topNav}>
          <div
            onClick={toggleHidden}
            className={s.asideToggler}
          >
            <span />
            <span />
            <span />
          </div>

          <LangSelect />

          <Link
            to="/settings"
            className={classNames(s.topNavLink, { [s.current]: pathname.includes('settings') })}
          >
            <Settings className={s.topNavIcon} /> {t('settings')}
          </Link>
          <Link
            to="/profile"
            className={s.topNavLink}
          >
            <Profile /> {localStorage.getItem('login')}
          </Link>
          <SignOut
            className={s.signOut}
            onClick={signOutHandler}
          />
        </div>

        <div className={s.mainWrapper}>
          <Outlet />
        </div>
      </div>

      {modalIsVisible && target && <CallModal />}
    </div>
  )
}
